import FuseUtils from '@fuse/utils';
import FuseLoading from '@fuse/core/FuseLoading';
import { Navigate } from 'react-router-dom';
import SignOutConfig from '../main/sign-out/SignOutConfig';
import Error404Page from '../main/404/Error404Page';
import Error404PageConfig from '../main/404/Error404PageConfig';

import LeadsConfig from '../main/processor-leads/LeadsConfig';
import MerchantConfig from '../main/merchant/MerchantConfig';
import ProcessorConfig from '../main/processor/ProcessorConfig';
import TermsAndPrivacyConfig from '../main/TermsAndPrivacy/TermsAndPrivacyConfig';
import ProcessorPreferencesConfig from '../main/processor-preferences/ProcessorPreferencesConfig';
import MerchantDashboardConfig from '../main/merchant-dashboard/DashboardConfig';
import MerchantOffersConfig from '../main/merchant-offers/MerchantOffersConfig';
import OfferTemplatesConfig from '../main/processor-offer-templates/OfferTemplatesConfig';
import ProcessorDashboardConfig from '../main/processor-dashboard/ProcessorDashboardConfig';
import ProcessorProfileConfig from '../main/processor-profile/ProcessorProfileConfig';
import MerchantProfileConfig from '../main/merchant-profile/MerchantProfileConfig';
import MerchantResubmitConfig from '../main/merchant-resubmit/MerchantResubmitConfig';
import MerchantOffersCompareConfig from '../main/merchant-offers-compare/MerchantOfferscompare';
import MerchantSupportConfig from '../main/support/MerchantSupportConfig';
import ProcessorSupportConfig from '../main/support/ProcessorSupportConfig';
import MerchantSignInConfig from '../main/merchant-signin/MerchantConfig';
import ProcessorDocumentsConfig from '../main/processor-documents/ProcessorDocumentsConfig';
import AdminDashboardConfig from '../admin/dashboard/AdminDashboardConfig';
import AdminLeadsConfig from '../admin/leads/AdminLeadsConfig';
import AdminMerchantsConfig from '../admin/merchants/AdminMerchantsConfig';
import AdminOffersConfig from '../admin/offers/AdminOffersConfig';
import OffersConfig from '../main/processor-offers/OffersConfig';
import AdminProcessorsConfig from '../admin/processors/AdminProcessorsConfig';
import AdminResubmitConfig from '../admin/resubmit-requests/AdminResubmitConfig';
import AdminAgentsConfig from '../admin/agents/AdminAgentsConfig';
import AdminRebatesConfig from '../admin/rebates/AdminRebatesConfig';
import AgentLeadsConfig from '../main/agent-leads/AgentLeadsConfig';
import AgentSupportConfig from '../main/support/AgentSupportConfig';
import AgentLeadConfig from '../main/merchant/AgentLeadConfig';
import AgentDashboardConfig from '../main/agent-dashboard/AgentDashboardConfig';
import AgentToolsConfig from '../main/agent-tools/AgentToolsConfig';
import AffiliateLeads from '../admin/affiliate-leads/AffiliateLeadsPage';
import ManagerDashboardConfig from '../manager/dashboard/ManagerDashboardConfig';
import ManagerLeadsConfig from '../manager/leads/ManagerLeadsConfig';
import ManagerMerchantsConfig from '../manager/merchants/ManagerMerchantsConfig';
import ManagerOffersConfig from '../manager/offers/ManagerOffersConfig';
import ManagerProcessorsConfig from '../manager/processors/ManagerProcessorsConfig';
import ManagerResubmitConfig from '../manager/resubmit-requests/ManagerResubmitConfig';
import ManagerAgentsConfig from '../manager/agents/ManagerAgentsConfig';
import ManagerRebatesConfig from '../manager/rebates/ManagerRebatesConfig';
import ManagerAffiliateLeadsConfig from '../manager/affiliate-leads/ManagerAffiliateLeadsConfig';

const adminConfig = [
  AdminDashboardConfig,
  AdminLeadsConfig,
  AdminMerchantsConfig,
  AdminOffersConfig,
  AdminProcessorsConfig,
  AdminResubmitConfig,
  AdminAgentsConfig,
  AdminRebatesConfig,
  SignOutConfig,
];

const managerConfig = [
  ManagerDashboardConfig,
  ManagerLeadsConfig,
  ManagerMerchantsConfig,
  ManagerOffersConfig,
  ManagerProcessorsConfig,
  ManagerResubmitConfig,
  ManagerAgentsConfig,
  ManagerRebatesConfig,
  SignOutConfig,
];

export const agentRoutes = [
  ...FuseUtils.generateRoutesFromConfigs([
    AgentLeadsConfig,
    SignOutConfig,
    AgentSupportConfig,
    AgentDashboardConfig,
    AgentToolsConfig,
  ]),
  {
    path: '/',
    element: <Navigate to="/agent/leads" />,
  },
  {
    path: '/agent',
    element: <Navigate to="/agent/leads" />,
  },
  {
    path: '/404',
    element: <Error404Page />,
  },
  {
    path: '*',
    element: <Error404Page />,
  },
];

export const adminRoutes = [
  ...FuseUtils.generateRoutesFromConfigs(adminConfig),
  {
    path: '/admin/affiliate-leads',
    element: <AffiliateLeads />,
  },
  {
    path: '/',
    element: <Navigate to="/admin/dashboard" />,
  },
  {
    path: '/admin',
    element: <Navigate to="/admin/dashboard" />,
  },
  {
    path: '/404',
    element: <Error404Page />,
  },
  {
    path: '*',
    element: <Error404Page />,
  },
];

export const managerRoutes = [
  ...FuseUtils.generateRoutesFromConfigs(managerConfig),
  ...FuseUtils.generateRoutesFromConfigs([ManagerAffiliateLeadsConfig]),
  {
    path: '/',
    element: <Navigate to="/manager/dashboard" />,
  },
  {
    path: '/manager',
    element: <Navigate to="/manager/dashboard" />,
  },
  {
    path: '/404',
    element: <Error404Page />,
  },
  {
    path: '*',
    element: <Error404Page />,
  },
];

export const processorOnboardingRoutes = [
  ...FuseUtils.generateRoutesFromConfigs([ProcessorConfig, SignOutConfig, TermsAndPrivacyConfig]),
  {
    path: '*',
    element: <Navigate to="/processor/login" />,
  },
  {
    path: '/processor/*',
    element: <Navigate to="/processor/login" />,
  },
];

const onboardingConfig = [
  ProcessorConfig,
  MerchantConfig,
  MerchantSignInConfig,
  Error404PageConfig,
  SignOutConfig,
  TermsAndPrivacyConfig,
  MerchantResubmitConfig,
  AgentLeadConfig,
];

export const onboardingRoutes = [
  ...FuseUtils.generateRoutesFromConfigs(onboardingConfig),
  {
    path: '/merchant',
    element: <Navigate to="/merchant/login" />,
  },
  {
    path: '/processor',
    element: <Navigate to="/processor/login" />,
  },
  {
    path: '/merchant/*',
    element: <Navigate to="/merchant/login" />,
  },
  {
    path: '/processor/*',
    element: <Navigate to="/processor/login" />,
  },
  {
    path: '*',
    element: <Navigate to="/merchant/login" />,
  },
];

const merchantConfigs = [
  MerchantDashboardConfig,
  MerchantOffersConfig,
  MerchantProfileConfig,
  SignOutConfig,
  Error404PageConfig,
  TermsAndPrivacyConfig,
  MerchantResubmitConfig,
  MerchantOffersCompareConfig,
  MerchantSupportConfig,
];
export const merchantRoutes = [
  ...FuseUtils.generateRoutesFromConfigs(merchantConfigs),
  {
    path: '/',
    element: <Navigate to="/merchant/dashboard" />,
  },
  {
    path: '/merchant',
    element: <Navigate to="/merchant/dashboard" />,
  },
  {
    path: '/merchant/login',
    element: <Navigate to="/merchant/dashboard" />,
  },
  {
    path: 'loading',
    element: <FuseLoading />,
  },
  {
    path: '/404',
    element: <Error404Page />,
  },
  {
    path: '*',
    element: <Error404Page />,
  },
];

const routeConfigs = [
  ProcessorDashboardConfig,
  LeadsConfig,
  OffersConfig,
  OfferTemplatesConfig,
  ProcessorSupportConfig,
  SignOutConfig,
  TermsAndPrivacyConfig,
  ProcessorPreferencesConfig,
  ProcessorProfileConfig,
  Error404PageConfig,
  MerchantResubmitConfig,
  ProcessorDocumentsConfig,
];

export const processorRoutes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
  {
    path: '/processor/login',
    element: <Navigate to="/processor/leads" />,
  },
  {
    path: '/',
    element: <Navigate to="/processor/leads" />,
  },
  {
    path: '/processor',
    element: <Navigate to="/processor/leads" />,
  },
  {
    path: 'loading',
    element: <FuseLoading />,
  },
  {
    path: '/404',
    element: <Error404Page />,
  },
  {
    path: '*',
    element: <Error404Page />,
  },
];

export const errorRoutes = [
  ...FuseUtils.generateRoutesFromConfigs([Error404PageConfig, SignOutConfig]),
  {
    path: '*',
    element: <Navigate to="/notFound" />,
  },
];
